import { styled, TextField } from '@mui/material';

export const StyledTextField = styled(TextField)(({ theme }) => ({
	width: '100%',
	color: theme.palette.text.primary,
	'& .MuiInputBase-input': {
		padding: '11px 17px',
		letterSpacing: '0.035rem',
		height: 'unset',
	},
	'& .MuiOutlinedInput-root': {
		padding: '0px',
		'& fieldset': {
			borderRadius: '0px',
			borderColor: theme.palette.text.primary,
		},
		'&.Mui-disabled': {
			backgroundColor: theme.palette.highlighted.secondary,
			WebkitTextFillColor: theme.palette.text.primary,
			input: {
				WebkitTextFillColor: theme.palette.text.primary,
			},
			fieldset: {
				border: 'none',
			},
		},
	},

	'& .MuiFormHelperText-root': {
		margin: '0',
		display: 'flex',
		alignItems: 'center',
		fontStyle: 'normal',
		fontSize: '0.7rem',
		lineHeight: '1rem',
		letterSpacing: '0.016rem',
	},
}));
